import { Avatar } from "@mui/material";
import { useEffect, useState } from "react";
import { getImageUrl } from "utils/imageUtils";

export interface AsyncAvatar {
    url: Promise<string>;
    props?: any;
}

export const AsyncAvatar = (props: AsyncAvatar) => {
    const [url, setUrl] = useState<string | undefined>(undefined);

    useEffect(() => {
        const getUrl = async() => {
            try {
                const url = await props.url;
                if (url) {
                    setUrl(getImageUrl(url));
                } else {
                    setUrl(undefined);
                }
            } catch {
                setUrl(undefined);
            }
        }

        getUrl();
    }, [props.url]);

    return <Avatar
            {...props}
            src={url ?? ''}
        />;
}